export enum MembershipApprovalMode {
  AUTO_ACCEPT = 'auto_accept',
  APPROVAL_REQUIRED = 'approval_required',
}

export const MEMBERSHIP_APPROVAL_MODE_LABELS: Record<
  MembershipApprovalMode,
  string
> = {
  [MembershipApprovalMode.AUTO_ACCEPT]: 'Anyone can join',
  [MembershipApprovalMode.APPROVAL_REQUIRED]: 'Approval required',
};

export const MEMBERSHIP_APPROVAL_MODE_ORDER: readonly MembershipApprovalMode[] = [
  MembershipApprovalMode.AUTO_ACCEPT,
  MembershipApprovalMode.APPROVAL_REQUIRED,
];
